export default __webpack_public_path__ + "static/media/fileUpload.6e606ef8.svg";